'use strict';
/**
 * @author Maxim Seredkin
 */
// angular
import angular from 'angular';
import maintenanceKind from './module/maintenance_kind';
import milestone from './module/milestone';
import municipality from './module/municipality';
import phase from './module/phase';
import supportTool from './module/support_tool';
import tax from './module/tax';
import ownershipForm from './module/ownership_form';
import hazardClasses from './module/hazard_classes';
import supportType from './module/supporttype';
import operationType from './module/operationtype';

export default angular.module('investmentProject.enchiridion.handbook',
    [maintenanceKind, milestone, municipality, phase, supportTool, tax, ownershipForm, hazardClasses, supportType, operationType])
    .name;

